import React from 'react';

import { withSubscription } from '@spotahome/soyuz-mediator';

import { TOKEN_EXPIRED } from '../channels';

import LoginModal from './login/LoginModal';
import withModalHandle from './withModalHandle';

const ExpiredModal = withSubscription({ channelName: TOKEN_EXPIRED })(props => (
  <LoginModal onClose={props.handleModalClose} isOpen={props.isModalOpen} />
));

const SessionExpiredModal = withModalHandle()(
  ({ handleModalOpen, ...restProps }) => (
    <ExpiredModal onEvent={handleModalOpen} {...restProps} />
  )
);

export default SessionExpiredModal;
